const GOOGLE_CLASSROOM = 'google_classroom';
const TT = 'tt';
const ZTE_SCUOLA = 'zte_scuola';
const ZTE_UNIVERSITA = 'zte_universita';
const ZTE_UNITUTOR = 'zte_unitutor';
const LAZE = 'laze';

export const SOURCES = {
    GOOGLE_CLASSROOM,
    TT,
    ZTE_SCUOLA,
    ZTE_UNITUTOR,
    ZTE_UNIVERSITA,
    LAZE,
};

const ZTE_SCUOLA_LABEL = 'ZTE SCUOLA';
const ZTE_UNIVERSITA_LABEL = 'ZTE UNIVERSITA';
const ZTE_UNITUTOR_LABEL = 'ZTE UNITUTOR';

export const SOURCES_LABEL = {
    ZTE_SCUOLA_LABEL,
    ZTE_UNIVERSITA_LABEL,
    ZTE_UNITUTOR_LABEL,
};
